<template>
	<div class="top-ups">
		<Modal
			:show="showAccountsModal"
			content_class="col-12 col-md-6 col-lg-5 payment-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Account List</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showAccountsModal', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="card card-details">
						<div
							class="account"
							v-for="(account, index) in all_client_accounts"
							:key="index"
						>
							<div class="title">
								{{ account.account_type }} -
								{{ account.account_number }}
							</div>
							<div class="bal">
								{{ account.currency_code }}
								<b>{{
									utils.numberWithCommas(
										Math.round(
											account.available_balance * 100,
										) / 100,
									)
								}}</b>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
		<Modal
			:show="paySavedPaymentOption"
			content_class="col-12 col-md-6 col-lg-5 payment-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Pay Via Saved Top Up Option
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="
								$store.commit('paySavedPaymentOption', false)
							"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="card card-details">
						<div class="option" v-if="selectedPaymentOption">
							<div class="option-box">
								<div class="clearfix">
									<div class="image-box f-l">
										<img
											v-if="selectedPaymentOption.icon"
											:src="
												api.getDomain() +
												selectedPaymentOption.icon
											"
											alt=""
											class="image"
										/>
										<img
											v-else
											src="/img/avatars/2.png"
											alt=""
											class="image"
										/>
									</div>
									<div class="name-box f-l">
										<div class="insurance">
											{{
												selectedPaymentOption.channel_name
											}}
										</div>
										<div class="txt">
											{{
												selectedPaymentOption.description
											}}
										</div>
									</div>
								</div>
							</div>

							<Form
								classBinding="row"
								:ref="TopUpModel.forms.account_details.name"
								:forms="TopUpModel.forms.account_details.forms"
								:form_data="
									TopUpModel.forms.account_details.data
								"
							/>

							<div class="button-box">
								<div
									class="btn btn-primary f-r"
									:disabled="loading"
									@click="
										topUpSaved({
											ref: $refs[
												TopUpModel.forms.account_details
													.name
											],
										})
									"
								>
									Top Up
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
		<Modal
			:show="showTopUpModal"
			content_class="col-12 col-md-8 col-lg-6 col-xl-5 payment-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Top Up</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showTopUpModal', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div
						class="previous-page clearfix"
						@click="goToPrevious()"
						v-show="currentPage > 1"
					>
						<div class="icon f-l">
							<i class="fa fa-arrow-left"></i>
						</div>
						<div class="txt f-l">Previous</div>
					</div>

					<div class="page" v-if="currentPage === 1">
						<Form
							classBinding="row"
							:ref="TopUpModel.forms.account_details.name"
							:forms="TopUpModel.forms.account_details.forms"
							:form_data="TopUpModel.forms.account_details.data"
						/>

						<div class="button-box">
							<div
								class="btn btn-primary f-r"
								:disabled="loading"
								@click="
									selectAccount({
										ref: $refs[
											TopUpModel.forms.account_details
												.name
										],
									})
								"
							>
								Next
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>

					<div class="page" v-if="currentPage === 2">
						<div class="form-item">
							<label class="form-label">Payment Type</label>
							<Select
								class="ivu-select"
								v-model="option"
								:clearable="true"
								placeholder="Select Type"
								@input="changePaymentType({ option })"
								:validation="'required'"
							>
								<Option
									v-for="item in paymentTypes"
									:value="item"
									:key="item.name"
									>{{ item.name }}</Option
								>
							</Select>

							<label class="form-label mt-4">Channel</label>
							<Select
								class="ivu-select"
								v-model="channel"
								:clearable="true"
								placeholder="Select Type"
								:validation="'required'"
							>
								<Option
									v-for="item in channels"
									:value="item"
									:key="item.channel_name"
									>{{ item.channel_name }}</Option
								>
							</Select>
						</div>

						<div class="button-box">
							<div
								class="btn btn-primary f-r"
								:disabled="loading"
								@click="moveToPaymentPage({ channel })"
							>
								Next
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
					<div class="page" v-show="currentPage === 3">
						<div class="title" v-if="option">
							{{ option.category }} - {{ channel.channel_code }}
						</div>

						<div
							v-show="
								channel &&
								channel.thirdparty_provider === 'STRIPE'
							"
						>
							<CheckoutStripe
								:amount="200"
								@payment-complete="checkoutStripe"
							/>
						</div>
						<div
							v-if="
								option.category === 'BANK' ||
								channel.channel_name === 'M-Pesa' ||
								channel.channel_code === 'AIRTEL'
							"
						>
							<div class="center card card-details">
								<div
									class="txt mt-4"
									v-html="paybillText"
								></div>

								<div class="ref" v-if="generatedRef.length > 0">
									{{ generatedRef }}
								</div>

								<div
									class="button-box"
									@click="generateRef({ channel, option })"
								>
									<div
										class="btn btn-primary center"
										:disabled="loading"
									>
										Generate Ref
										<div class="lds-ring" v-show="loading">
											<div></div>
											<div></div>
											<div></div>
											<div></div>
										</div>
									</div>
								</div>
							</div>

							<div
								class="button-box"
								v-if="generatedRef.length > 0"
								@click="moveToConfirmation({})"
							>
								<div
									class="btn btn-primary f-r"
									:disabled="loading"
								>
									Continue
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="
								channel.thirdparty_provider === 'MPESA_CHECKOUT'
							"
						>
							<Form
								classBinding="row"
								:ref="TopUpModel.forms.mpesa_checkout.name"
								:forms="TopUpModel.forms.mpesa_checkout.forms"
								:form_data="
									TopUpModel.forms.mpesa_checkout.data
								"
							/>

							<div class="button-box">
								<div
									class="btn btn-primary f-r"
									:disabled="loading"
									@click="
										checkoutMpesa({
											ref: $refs[
												TopUpModel.forms.mpesa_checkout
													.name
											],
										})
									"
								>
									Next
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="page" v-if="currentPage === 4">
						<div class="confirmation">
							<div class="title">Account Details</div>
							<div class="card card-details">
								<div class="clearfix">
									<div class="f-l">Account</div>
									<div class="f-r bolder">
										{{ accountData.account.account_number }}
									</div>
								</div>
								<div class="clearfix">
									<div class="f-l">Currency</div>
									<div class="f-r bolder">
										{{ accountData.account.currency_code }}
									</div>
								</div>
								<div class="clearfix">
									<div class="f-l">Balance</div>
									<div class="f-r bolder">
										{{
											utils.numberWithCommas(
												Math.round(
													accountData.account
														.available_balance *
														100,
												) / 100,
											)
										}}
									</div>
								</div>
							</div>

							<div class="title">Payment Options</div>
							<div class="card card-details mt-3">
								<div class="clearfix">
									<div class="f-l">Mode</div>
									<div class="f-r bolder">
										{{ option.name }}
									</div>
								</div>
								<div class="clearfix">
									<div class="f-l">Channel</div>
									<div class="f-r bolder">
										{{ channel.channel_name }}
									</div>
								</div>
								<div class="clearfix">
									<div class="f-l">Amount</div>
									<div class="f-r bolder">
										{{
											utils.numberWithCommas(
												Math.round(
													accountData.amount * 100,
												) / 100,
											)
										}}
									</div>
								</div>
							</div>
							<!-- {{TopUpModel.forms.top_up.data }} -->
							<Form
								classBinding="row"
								:ref="TopUpModel.forms.top_up.name"
								:forms="TopUpModel.forms.top_up.forms"
								:form_data="TopUpModel.forms.top_up.data"
							/>

							<div class="button-box">
								<div
									class="btn btn-primary f-r"
									:disabled="loading"
									@click="
										topUp({
											ref: $refs[
												TopUpModel.forms.top_up.name
											],
											channel,
											option,
										})
									"
								>
									Top Up
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<div class="row">
			<div class="col-12">
				<div class="row">
					<div class="col-12 col-md-11 col-lg-7 col-xl-6">
						<div class="title-content clearfix">
							<div class="title f-l">Top Up Options</div>
							<div class="balance f-r">
								<div
									class="f-l btn btn-sm btn-grey"
									@click="
										$store.commit('showAccountsModal', true)
									"
								>
									<span>SHOW</span>
								</div>
							</div>
						</div>

						<div class="topup-details">
							<div class="saved">
								<div
									class="message"
									v-if="all_client_accounts.length === 0"
								>
									No Top-Up Options Saved
								</div>
								<div v-else>
									<Form
										classBinding="row"
										:ref="
											TopUpModel.forms
												.saved_top_up_options.name
										"
										:forms="
											TopUpModel.forms
												.saved_top_up_options.forms
										"
										:form_data="
											TopUpModel.forms
												.saved_top_up_options.data
										"
									/>
								</div>
							</div>
							<div class="payment clearfix">
								<div class="icon-box f-l">
									<i class="fa fa-plus"></i>
								</div>
								<div
									class="txt f-l"
									@click="
										$store.commit('showTopUpModal', true)
									"
								>
									Top Up
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6 col-lg-5 col-xl-5 offset-xl-1">
						<Advert />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import topUps from '../rsc/stores/topup.store';
import { Option } from '@/libs/clarks/components/select/index';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	components: {
		Advert: () => import('../templates/ads/advert'),
		Select: () => import('@/libs/clarks/components/select/index'),
		InputText: () => import('@/libs/clarks/components/text'),
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('../templates/others/modal'),
		CheckoutStripe: () => import('./checkout'),
		AdFeatures: () => import('../templates/ads/ad-features'),
		Option,
	},
	beforeDestroy() {
		this.$store.unregisterModule('topUps');
		Event.$off('select-field-changed');
	},
	created() {
		utils.registerModule('topUps', topUps, this.$store);
		Event.$on('select-field-changed', (payload) => {
			this.selectFieldChanged(payload);
		});
	},
	computed: {
		...mapGetters([
			'api_key',
			'loading',
			'showTopUpModal',
			'showAccountsModal',
			'paySavedPaymentOption',
			'selectedPaymentOption',
			'showBalance',
			'TopUpModel',
			'paymentTypes',
			'currency',
			'stripe',
			'cardElement',
			'currentPage',
			'element',
			'all_client_accounts',
			'channels',
			'generatedRef',
			'paybillText',
			'accountData',
			'mpesaData',
		]),
	},
	data() {
		return {
			api,
			utils,
			option: '',
			channel: '',
		};
	},
	methods: {
		...mapActions([
			'fetchData',
			'topUp',
			'topUpSaved',
			'selectAccount',
			'changePaymentType',
			'moveToPaymentPage',
			'generateRef',
			'moveToConfirmation',
			'checkoutMpesa',
			'checkoutStripe',
			'goToPrevious',
			'selectFieldChanged',
		]),
		changeForm() {
			if (this.type.val === 'CARD') {
				this.cardElement.mount('#card-element');
			}
		},
	},
	async mounted() {
		utils.registerModule('topUps', topUps, this.$store);
		await this.fetchData();
	},
};
</script>

<style lang="less">
.top-ups {
	.option-box {
		border-radius: 4px;
		padding: 20px 15px;
		margin: 10px 0;
		cursor: pointer;

		.image-box {
			margin: 0 30px 0 0;

			.image {
				border-radius: 50%;
				width: 50px;
				height: 50px;
			}
		}
		.name-box {
			margin: 7px 0 0 0;

			.insurance {
				font-size: 14px;
				color: var(--text-color);
				font-family: var(--font-bold);
				line-height: 13px;
			}
			.txt {
				font-weight: 600;
				font-size: 13px;
			}
		}
	}
	.card-details {
		.clearfix {
			font-size: 14px;
			margin: 1px 0;

			.bolder {
				font-weight: 600;
			}
		}
	}
	.page {
		.title {
			font-weight: 600;
			font-size: 13px;
		}
	}
	.previous-page {
		margin: 10px 0 25px 0;
		font-size: 14px;
		color: var(--primary);
		cursor: pointer;

		.txt {
			font-weight: 600;
			margin: 0 0 0 10px;
		}

		&:hover {
			.txt {
				text-decoration: underline;
			}
		}
	}
	.center {
		text-align: center;

		.ref {
			font-family: var(--font-bolder);
			font-size: 36px;
			margin: 20px 0 15px 0;
		}
	}
	.account {
		padding: 15px 0;
		border-bottom: solid 1px #efefef;

		.title {
			font-size: 13px;
			font-weight: 600;
		}
		.bal {
			font-size: 12px;

			b {
				font-size: 16px;
				color: var(--ne-red);
			}
		}
	}
	.saved {
		padding: 25px 0 40px 0;
		border-bottom: solid 1px #efefef;
		margin: 0 0 10px 0;

		.message {
			text-align: center;
			font-weight: 600;
			font-size: 13px;
		}
	}
	.payment-modal {
		.button-box {
			margin: 40px 10px 0 0;
		}
		.form-item {
			margin: 0 10px;
		}

		.forms {
			margin: 20px 0 0 0;
		}
	}
	.topup-details {
		padding: 30px 20px;
		border-radius: 4px;
		border: solid 1px #e6eaee;
		background: var(--white);

		.payment {
			// margin: 100px 0 0 0;
			padding: 20px 0;
			// border-bottom: solid 1px #e6eaee;

			.icon-box {
				background: #eeeef2;
				width: 50px;
				height: 50px;
				border-radius: 20px;
				margin: 0 20px 0 0;
				font-size: 18px;
				padding: 15px 0 0 0;
				text-align: center;
				color: #9c7bfc;
			}
			.txt {
				color: #9c7bfc;
				font-weight: 600;
				font-size: 15px;
				margin: 13px 0 0 0;
				position: relative;
				cursor: pointer;
			}
			.txt:hover {
				text-decoration: underline;
			}
		}
		.options {
			margin: 30px 0;

			.selector {
				border-radius: 4px;
				box-shadow: 0 10px 23px 0 #9292d219;
				padding: 15px 10px;
			}
			.title {
				font-weight: 600;
				font-size: 15px;
			}
		}
	}
	.balance {
		.btn-grey {
			padding: 5px 20px !important;
		}
	}
	.amount {
		font-weight: 600;
		font-size: 15px;
		line-height: 12px;

		.point {
			font-size: 11px;
		}
		.txt {
			font-size: 11px;
			margin: 3px 0 0 0;
			color: var(--text-grey);
			font-weight: 600;
		}
	}
	.btn.btn-primary {
		display: inline-block;
		width: auto !important;
		color: var(--white);
		background: var(--primary);
		padding: 10px 20px;
		font-weight: 400;
	}
	.btn-primary:hover {
		background: lighten(#003c80, 10%);
	}
	.btn-sm {
		margin: 0 10px;
		padding: 1px 15px;
		font-size: 12px;
	}
	.btn-yellow {
		background: var(--ne-yellow);
		color: var(--white);
		width: 100%;
	}
	.btn-grey {
		background: #bfc7d133;
	}
	.btn-grey:hover {
		background: darken(#bfc7d133, 5%);
		color: var(--text-color);
	}
	.btn-yellow:hover {
		background: darken(#ff9f00, 2%);
	}
}
</style>
